import React from "react";
import Img from 'gatsby-image';
import { Helmet } from 'react-helmet';
import styles from './journey.module.css';
import Email from '../components/email';

export default ({ data }) => {
  const page = data.markdownRemark;
  const html = page.html.split('<!-- break -->');
  return (
    <main>
      <Helmet title={page.frontmatter.title + ' - Quo Vadis Journeys'} />
      <div className={styles.header} >
        <Img
          className={styles.background}
          outerWrapperClassName={styles.background}
          sizes={page.frontmatter.image.childImageSharp.sizes}
          />
        <div className={styles.titleDiv}>
          <h1 className={styles.title}>{page.frontmatter.title}</h1>
          <h2>{page.frontmatter.dates}</h2>
        </div>
      </div>
      <div className={styles.topSection} >
				<Img
					className={styles.sideImage}
					resolutions={page.frontmatter.sideImage.childImageSharp.resolutions}
					/>
				<div className={styles.text} dangerouslySetInnerHTML={{ __html: html[0] }} />
			</div>
			<div className={styles.section}>
				<div className={styles.details} dangerouslySetInnerHTML={{ __html: html[1] }} />
				<div className={styles.text} dangerouslySetInnerHTML={{ __html: html[2] }} />
			</div>
      <Email />
    </main>
  );
};

export const query = graphql`
  query JourneyPageQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        dates
        image {
          childImageSharp {
            sizes(maxWidth: 1920) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        sideImage {
          childImageSharp {
            resolutions(width: 280, height: 400, cropFocus: CENTER) {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/journey.js